import configData from '../common/configData.json';

const defaultCountryCode = configData?.common.vn.countryCode;

export const getIsBTPEndpoint = (selectedCountryCode) => {
    const countryCode = selectedCountryCode ?? defaultCountryCode;
    return configData?.common[countryCode]?.BTPEndpoint;
}

const getMsMuleEndpoint = (countryCode) => {
    switch (countryCode) {
        case 'id':
            return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPMicroserviceEndpointId : configData.mulesoftConfig.microserviceEndpointId;
        case 'idic':
            return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPMicroserviceEndpointIdIC : configData.mulesoftConfig.microserviceEndpointIdIc;
        case 'pk':
            return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPMicroserviceEndpointPk : configData.mulesoftConfig.microserviceEndpointPk;
        case 'bd':
            return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPMicroserviceEndpointPk : configData.mulesoftConfig.microserviceEndpointPk;
        default:
            return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPMicroserviceEndpoint : configData.mulesoftConfig.microserviceEndpoint;
    }
};

export const getClientId = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTP_client_id : configData.mulesoftConfig.client_id;
}

export const getClientSecret = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTP_client_secret : configData.mulesoftConfig.client_secret;
}

export const getEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPEndpoint : configData.mulesoftConfig.muleEndpoint;
}

export const getExpEndpoint = (countryCode) => {
    if (countryCode === "idic") {
        return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPExpEndpointIdIc : configData.mulesoftConfig.muleExpEndpointIdIc;
    } else {
        return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPExpEndpoint : configData.mulesoftConfig.muleExpEndpoint;
    }
}

export const getMicroserviceEndpoint = (countryCode) => {
    return getMsMuleEndpoint(countryCode);
}

export const getCohortEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPCohortEndpoint : configData.mulesoftConfig.microserviceEndpoint;
}

export const getCheckstatusEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? 'file/checkstatus' : 'exp/file/checkstatus';
}

export const getUploadEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? 'file/upload' : 'exp/file/upload';
}

export const getDownloadEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? 'file/download/' : 'exp/file/download/';
}

export const getMerchandiserEndpoint = (countryCode) => {
    return getIsBTPEndpoint(countryCode) ? configData.mulesoftConfig.BTPMerchandiserEndpoint : configData.mulesoftConfig.microserviceEndpoint;
}